import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { I18nService } from '@app/@core/services';
import { CONSTANSTS } from '@core/constants';
import { StorageService } from '@core/services/storage.service';
import { environment } from '@env/environment';
import { UsersService } from '@services/users.service';
import { UserModel } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthService {

  constructor(
    private router: Router,
    private http: HttpClient,
    private storageService: StorageService,
    private usersService: UsersService,
    private readonly i18nService: I18nService
  ) { }

  /**
   * login method
   * @param login
   */
  login(login: any): Observable<UserModel> {
    return this.http.get<UserModel>(CONSTANSTS.api.default.login, { params: login })
      .pipe(map((user: UserModel) => user));
  }

  /**
   * logout
   */
  logout(url?: string): void {
    this.usersService.userSubject.next(null);
    this.storageService.clear();
    window.location.href = environment.tempUrl + '/logout/lang=' + this.i18nService.language;

    // bu alan angular projeseine tam geçiş yapıldığında aktif olacaktır.
    // this.router.navigate(['/login'], { queryParams: { returnUrl: url } });
  }
}
